<template>
    <div id="myCollection">
        <ul class="main-top">
            <li
                v-for="(item,index) in nav"
                :key="index"
                :class="{'active':i==index}"
                @click="select(index,item.type)"
            >{{item.name}}</li>
        </ul>
        <!-- 商品  -->
        <div class="main" v-if="i==0">
            <div class="wrap">
                <div class="ProductList" v-for="(item,index) in datalist" :key="index">
                    <div class="ProductImgs" @click.stop="goDetail(item.id,item.show)">
                        <img :src="$store.state.imgUrl+item.atPhotoUrl" alt />
                        <p class="Collection" @click.stop="Collection(item.id,'2')">
                            <span>取消收藏</span>
                            <i class="el-icon-star-on"></i>
                        </p>
                    </div>
                    <div class="Product Product1">
                        <div class="ProductW">
                            <p class="p1" @click="goDetail(item.id,item.show)">
                                <span class="tit">{{item.pinyinName}}</span>
                                <span class="tit2" v-if="item.optYhlx==1">{{item.zkbl}}折</span>
                                <span class="tit2 tit2" v-if="item.optYhlx==2">{{'团购'}}</span>
                            </p>
                            <p class="p2" @click="goDetail(item.id,item.show)">{{item.atSpmc}}</p>
                        </div>
                        <div class="p3">
                            <p class="money">
                                <span v-if="item.optYhlx==2 ||item.optYhlx==3" class="buyPrice">
                                    ￥{{item.atYpdj}}
                                </span>
                                <span v-if=" item.optYhlx==1">
                                    <span class="buyPrice">
                                        ￥{{item.yhjg}}
                                    </span>
                                    <span class="oldPrice">
                                        ￥{{item.atYpdj}}
                                    </span>
                                </span>
                            </p>
                            <!-- <p class="car" @click="addCar(item.id)">
                                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="page">
                <el-pagination
                    background
                    layout="total,prev, pager, next,jumper"
                    :total="datas.total"
                    :page-size="pageSize"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 中医讲堂 -->
        <div class="main" v-if="i==1">
            <div class="wrap zyjt">
                <div
                    class="ProductList ProductList1-1"
                    v-for="(item,index) in datalist"
                    :key="index"
                >
                    <div class="ProductImgs" @click.stop="jiangtangVs(item.type,item.id,item.show)">
                        <video src controls :poster="item.stanceImg" v-if="item.type==0"></video>
                        <img :src="$store.state.imgUrl+item.stanceImg" alt v-else />
                        <p class="Collection" @click.stop="Collection(item.id,'3')">
                            <span>取消收藏</span>
                            <i class="el-icon-star-on"></i>
                        </p>
                    </div>
                    <div class="Product">
                        <p
                            class="p2"
                            @click="jiangtangVs(item.type,item.id,item.show)"
                        >{{item.name}}</p>
                    </div>
                </div>
            </div>
			
            <div class="page">
                <el-pagination
                    background
                    layout="total,prev, pager, next,jumper"
                    :total="datas.total"
                    :page-size="pageSize"
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                ></el-pagination>
            </div>
        </div>
        <!-- 中医文库收藏 -->
        <div class="main" v-if="i==2">
           

			 <div class="wrap">
                <div
                    class="ProductList ProductList1-1"
                    v-for="(item,index) in datalist"
                    :key="index"
                >
					<div class="ProductImgs" @click.stop="wenkuD(item.id,item.show)">
                        <img src="@/assets/img/13.png" alt />
                        <p class="Collection" @click.stop="Collection(item.id,'4')">
                            <span>取消收藏</span>
                            <i class="el-icon-star-on"></i>
                        </p>
                    </div>
                    <div class="ProductListR">
                        <h3>{{item.name}}</h3>
                        <p>{{item.author}}</p>
                        <p class="unCollection" @click="Collection(item.id,'4')">取消收藏</p>
                    </div>
                </div>
            </div>
         

            <div class="page">
                <el-pagination
                    background
                    layout="total,prev, pager, next,jumper"
                    :total="datas.total"
                    :page-size="pageSize"
                    @size-change="handleSizeChange3"
                    @current-change="handleCurrentChange3"
                ></el-pagination>
            </div>
        </div>
        <!-- 经络穴位收藏 -->
        <div class="main" v-if="i==3">
            <div class="wrap">
                <div class="ProductList3" style="width:100%">
                    <h3 class="Classification">经络</h3>
                    <ul class="ClassificationMain">
                        <li v-for="(item,index) in datalistJL" :key="index">
                            <p @click="jingluoD(item.id,item.show)">{{item.name}}</p>
                            <p @click="Collection(item.id,'5')">取消</p>
                        </li>
                    </ul>
                    <h3 class="Classification">穴位</h3>
                    <ul class="ClassificationMain">
                        <li v-for="(item,index) in datalistXW" :key="index">
                            <p @click="xueweiD(item.id,item.collectionId,item.show)">{{item.name}}</p>
                            <p @click="Collection(item.id,'6')">取消</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="page">
                <el-pagination
                    background
                    layout="total,prev, pager, next,jumper"
                    :total="datas.total"
                    :page-size="pageSize"
                    @size-change="handleSizeChange4"
                    @current-change="handleCurrentChange4"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
  <script>
export default {
    name: "Shopping",
    data() {
        return {
            datalist: [],
            datas: [], //所有数据
            datalistJL: [], //经络
            datalistXW: [], //穴
            userId: "", //用户id
            nav: [
                { name: "商品", type: "6" },
                { name: "中医讲堂", type: "3" },
                { name: "中医文库", type: "4" },
                { name: "经络穴位", type: "2" }
            ],
            i: 0, //nav下标
            type: "6",
            pageNum: 1,
            pageNum2: 1,
            pageNum3: 1,
            pageNum4: 1,
            pageSize: 8
        };
    },
    components: {},

    created() {
        // if (sessionStorage.getItem("CollectionIndex")) {
        //     //进入页面默认显示的选项卡
            // this.i = sessionStorage.getItem("CollectionIndex");
            this.i = 0;
            this.type = this.nav[this.i].type;
        // }
        if (!this.isLoginF()) return false;
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.userId = this.userInfo.id;
        if (this.$route.query.i) {
            this.i = this.$route.query.i;
            if (this.i == 1) {
                this.type = "3"; //讲堂
            } else if (this.i == 2) {
                this.type = "4"; //文库
            } else if (this.i == 3) {
                this.type = "2"; //经络穴位
            }
        }
        this.getData();
    },
    methods: {
        getData() {
            var params = {};
            params.userId = this.userInfo.id;
            params.collectionType = this.type;
            params.pageSize = this.pageSize;
            if (this.i != 3) {
                //不是穴位

                if (this.i == 0) {
                    //商城
                    params.pageNum = this.pageNum;
                } else if (this.i == 1) {
                    //中医讲堂
                    params.pageNum = this.pageNum2;
                } else if (this.i == 2) {
                    //中医文库
                    params.pageSize = 12;
                    params.pageNum = this.pageNum3;
                }
            } else {
                params.pageSize = 24;
                params.pageNum = this.pageNum4;
            }
            let url = "/collection/page";
            this.$http.post(url, params).then(res => {
                if (res.data.code == 200) {
                    console.log(res, 456);
                    this.datas = res.data.data;
                    this.datalist = res.data.data.list;
                    if (this.type == "6") {
                        for (var j = 0; j < this.datalist.length; j++) {
                            this.datalist[j].atPhotoUrl = this.datalist[
                                j
                            ].atPhotoUrl.split(",")[0];
                        }
                    } else if (this.type == "2") {
                        this.datalistJL = []; //经络
                        this.datalistXW = []; //穴位
                        for (var i = 0; i < this.datalist.length; i++) {
                            if (this.datalist[i].type == 0) {
                                this.datalistJL.push(this.datalist[i]); //经络
                            } else if (this.datalist[i].type == 1) {
                                this.datalistXW.push(this.datalist[i]); //穴位
                            }
                        }
                    }
                }
            });
        },
        // 去讲堂详情
        jiangtangVs(type, id, show) {
            if (show == 0) {
                this.$message({
                    type: "warning",
                    message: "已下架"
                });
                return false;
            }
            let that = this;
            if (type == "0") {
                // 视频类
                that.$router.push({
                    path: "/ForumDetailv",
                    query: { type: type, id: id }
                });
            } else {
                // 文章类
                that.$router.push({
                    path: "/ForumDetailw",
                    query: { type: type, id: id }
                });
            }
        },
        //文库详情
        wenkuD(id, show) {
            if (show == 0) {
                this.$message({
                    type: "warning",
                    message: "已下架"
                });
                return false;
            }
            this.$router.push({
                path: "/weiKuDetail",
                query: { id: id }
            });
        },
        //穴位详情
        xueweiD(id, meridiansId, show) {
            console.log(id, meridiansId);
            if (show == 0) {
                this.$message({
                    type: "warning",
                    message: "已下架"
                });
                return false;
            }
            this.$router.push({
                path: "/xueWeiDetail",
                query: { id: id, meridiansId: meridiansId }
            });
        },
        //经络详情
        jingluoD(id, show) {
            if (show == 0) {
                this.$message({
                    type: "warning",
                    message: "已下架"
                });
                return false;
            }
            this.$router.push({
                path: "/JingLuoDetail",
                query: { id: id }
            });
        },
        select(index, type) {
            this.i = index;
            sessionStorage.setItem("CollectionIndex", index); //刷新后显示
            this.type = type;
            this.getData();
        },
        goDetail(id, show) {
            if (show == 0) {
                this.$message({
                    type: "warning",
                    message: "已下架"
                });
                return false;
            }
            //跳转详情
            console.log(id);
            this.$router.push({ path: "/ProductDetails/" + id });
        },
        addCar(id) {
            //轮播图
            let url = "/gwcgl/save";
            var params = {};
            if (this.userId) {
                params.userId = this.userId;
                params.spSpgl = id;
                params.atSpsl = "1";
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        console.log(res);
                        this.$message({
                            message: "添加购物车成功！",
                            type: "success"
                        });
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                    }
                });
            } else {
                this.$confirm("您还未登录，是否登录", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        this.$router.replace({ path: "/login" });
                    })
                    .catch(() => {});
            }
        },
        Collection(id, type) {
            this.$confirm("此操作将取消收藏, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                //判断是否收藏
                var params = {};
                params.id = id;
                params.type = type; //1:草药 2：商品 3：视频 4：文库 5：经络 6：穴位
                params.userId = this.userId;
                var url = "/common/unCollection";
                //分类渲染
                this.$http.post(url, params).then(res => {
                    if (res.data.code == 200) {
                        console.log(res);
                        this.$message({
                            type: "success",
                            message: "取消成功!"
                        });
                        this.getData();
                    } else {
                        this.$message({
                            type: "warning",
                            message: "取消失败!"
                        });
                    }
                });
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.getData();
        },
        handleSizeChange2(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange2(val) {
            console.log(`当前页: ${val}`);
            this.pageNum2 = val;
            this.getData();
        },
        handleSizeChange3(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange3(val) {
            console.log(`当前页: ${val}`);
            this.pageNum3 = val;
            this.getData();
        },
        handleSizeChange4(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange4(val) {
            console.log(`当前页: ${val}`);
            this.pageNum4 = val;
            this.getData();
        }
    }
};
</script>
<style  scoped>
#myCollection {
    width: 99.8%;
    padding-bottom: 0px;
}
#myCollection::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.main-top {
    width: 100%;
    height: 46px;
    background-color: #ffffff;
    border: solid 1px #dddddd;
    margin-bottom: 10px;
}
.main-top li {
    float: left;
    width: 100px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 14px;
    letter-spacing: 0px;
    font-weight: 600;
    color: #333333;
    cursor: pointer;
    margin-right: 20px;
}
.main-top li.active {
    border-bottom: 3px solid #f64420;
    color: #f64420;
}
.main{
	clear: both;
}
.wrap {
    min-height:520px;
    overflow-y:  hidden !important;
    display: flex;
}
.ProductList {
    width: 23.5%;
    height:160px!important;
    margin: 20px 10px 0 0;
}
.ProductList .ProductImgs {
    width: 100%;
    height: 145px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}
.ProductImgs img {
    width: 100%;
    min-height: 100%;
}

.ProductImgs {
    position: relative;
}
.ProductImgs .Collection {
    width: 100%;
    position: absolute;
    background: rgba(207, 201, 200, 0.7);
    z-index: 100;
    left: 0;
    top: 115px;
    box-sizing: border-box;
    padding: 0 10px;
    cursor: pointer;
}
.Collection span {
    display: block;
    float: left;
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    margin-left: 60px;
    color: #fff;
}
.Collection i {
    display: block;
    float: right;
    font-size: 25px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    color: #fff;
}
.ProductList1-1 {
    height: 200px;
    margin-right: 8px;
}
video {
    width: 100%;
}
.ProductList1-1 .Product {
    height: 40px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.ProductList1-2 {
    height: 150px;
    margin-right: 8px;
}
.ProductListL {
    float: left;
    width: 48%;
    height: 100%;
    overflow: hidden;
    position: relative;
}
.ProductListL img {
    width: 100%;
    min-height: 100%;
    cursor: pointer;
}
.ProductListL .book {
    position: absolute;
    height: 80px;
    /* 字体纵向显示 */
    word-wrap: break-word;
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: tb-lr;
    writing-mode: vertical-lr;
    text-align: center;
    border: 1px solid #000;
    z-index: 100;
    background: #fff;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.ProductListR {
  	width: 100%; 
    height: 40%!important;
    background: #fff;
	overflow: hidden;
    box-sizing: border-box;
    padding: 0 10px;
}
.ProductListR h3 {
    font-size: 16px;
    margin: 10px 0 0 0;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ProductListR p {
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    cursor: pointer;
}
.ProductListR .unCollection {
    width: 80%;
    height: 20px;
    line-height: 20px;
    color: #fff;
    background: #f64420;
    text-align: center;
    font-size: 14px;
    float: right;
    border-radius: 5px;
    margin-top: 30px;
    cursor: pointer;
}
.Classification {
    width: 100px;
    height: 30px;
    line-height: 30px;
    margin-bottom: 0px;
}
.ClassificationMain {
    width: 100%;
}
.ClassificationMain::after {
    content: "";
    display: block;
    clear: both;
    height: 0;
    visibility: hidden;
    overflow: hidden;
}
.ClassificationMain li {
    float: left;
}
.ClassificationMain li p {
    float: left;
    height: 40px;
    border: 1px solid #ddd;
    margin-top: 20px;
    font-size: 16px;
    text-align: center;
}
.ClassificationMain li p:nth-child(1) {
    line-height: 40px;
    padding: 0 20px;
    cursor: pointer;
}
.ClassificationMain li p:nth-child(2) {
    width: 20px;
    line-height: 20px;
    font-size: 13px;
    color: #fff;
    background: #f64420;
    cursor: pointer;
}
.Product{
    height:60px!important;
    background: #fff;
}
.Product .p1 {
    width: 100%;
    height: 25px;
    line-height: 25px;
    font-size: 14px;
}
.Product .p1 .tit {
    display: block;
    float: left;
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #909090;
}
.Product .p1 .tit2 {
    display: block;
    float: right;
    height: 20px;
    line-height: 20px;
    width: 40px;
    text-align: center;
    border: 1px solid #f74320;
    background: #ffece8;
    margin-right: 10px;
    color: #f74320;
}
.Product .p1 .tit22 {
    border: 1px solid #64b9f2;
    background: #e8f7fe;
    color: #64b9f2;
}
.Product1 .p3{
    margin-top: 7px!important;
}
.Product .p2 {
    padding-left:10px;
    color: #666;
    font-size: 15px;
    float: left;
    width: 130px;
    height: 25px;
    line-height: 25px;
    white-space: nowrap!important; /* 确保文本在一行内显示 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 使用省略号表示文本溢出 */
}
.zyjt .Product .p2{
    padding:0 10px;
    width: 100%;
    box-sizing: border-box;
}
.Product .ProductW {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 5px;
}
.Product .ProductW .p1{
    float: right;
    width: 26%;
}
.Product .p3 .car {
    width: 27px;
    height: 27px;
    line-height: 27px;
    margin-right: 10px;
}
.p3 .money .oldPrice {
    text-decoration: line-through;
    font-size: 12px;
    color: #999;
}
.Product .p3 .money {
    float: left;
    width: 60%;
    text-indent: 7px;
}
.p3 .money span {
    color: #f74320;
    font-size: 16px;
    font-weight: 600;
}
.p3 .money i {
    color: #999;
    font-size: 16px;
    font-style: normal;
}
.money .buyPrice {
    font-size: 18px;
}
.page{
	width:100%;
}
/* 控制面板样式 */
.ProductList video::-webkit-media-controls-panel {
  background: linear-gradient(to bottom, transparent 55%, rgba(0,0,0,.3) 90%, rgba(0,0,0,.5)100%) !important;
}
</style>
 <style>
#myCollection .el-pagination {
    padding: 10px 0px;
}
</style>            




// WEBPACK FOOTER //
// src/components/Orderlist/myCollection.vue